module.exports = __webpack_public_path__ + "static/media/5.a9b2b4b8.png";